export default function genererEmplacementTechnique() {
  return {
    natureSol: null,
    codeBarre: '',
    degreDeniveleTerrain: 0,
    accesSiteSurRdv: false,
    acces: '',
    groupeDhabitation: '',
    numUG: '',
    quartier: '',
  };
}
